import { InjectionToken } from '@angular/core';
import { SystemPreferencesSettings } from '../models/logins/system-preferences-settings';

export interface SystemPreferences extends SystemPreferencesSettings {
}

export const SYSTEM_PREFERENCES: InjectionToken<SystemPreferences> = new InjectionToken<SystemPreferences>('SystemPreferences');
